// Shared 24px geometry keeps navigation and activity icons visually aligned.
export const icons = {
    menu: ['M4 3h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z', 'm17 2 5 5-5 5-5-5 5-5Z', 'M4 15h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Z', 'M15 15h5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Z'],
    home: ['m3 10 9-7 9 7', 'M5 9v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9', 'M9 21v-7h6v7'],
    users: ['M14 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z', 'M3 21v-2a6 6 0 0 1 12 0v2', 'M17 4a3.5 3.5 0 0 1 0 7', 'M18 14a5 5 0 0 1 3 5v2'],
    diamond: ['m3 8 4-5h10l4 5-9 13L3 8Z', 'M3 8h18M8 8l4 13 4-13M7 3l1 5m9-5-1 5'],
    account: ['M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z', 'M4 21v-2a8 8 0 0 1 16 0v2H4Z'],
    gift: ['M3 8h18v5H3V8Zm2 5v8h14v-8M12 8v13', 'M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z'],
    calendar: ['M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2ZM7 2v4m10-4v4M3 9h18', 'm8 15 3 3 5-6'],
    wheel: ['M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z', 'M12 3v6m0 6v6M3 12h6m6 0h6M5.6 5.6l4.3 4.3m4.2 4.2 4.3 4.3M5.6 18.4l4.3-4.3m4.2-4.2 4.3-4.3', 'M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'],
    chest: ['M3 11V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v3H3Zm0 0v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8M8 3v8m8-8v8', 'M10 10h4v6h-4v-6Zm2 6v2'],
    headset: ['M4 13v-2a8 8 0 0 1 16 0v2', 'M4 11h2v8H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2Zm16 0h-2v8h2a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2ZM20 19a3 3 0 0 1-3 3h-3'],
    ticket: ['M3 5h18v5a2 2 0 0 0 0 4v5H3v-5a2 2 0 0 0 0-4V5Z', 'M15 5v2m0 4v2m0 4v2M6 9h5m-5 6h3'],
    chat: ['M21 11a8 8 0 0 1-8 8H9l-6 3 1.5-6A8 8 0 1 1 21 11Z', 'M8 10h8m-8 4h5'],
    refresh: ['M20 8a8 8 0 0 0-13-4L3 8m0-5v5h5', 'M4 16a8 8 0 0 0 13 4l4-4m0 5v-5h-5'],
    wallet: ['M3 7h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12v4', 'M12 11v6m-3-3h6'],
    card: ['M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z', 'M2 9h20M6 15h4m4 0h3'],
    sparkles: ['m10 3 2.5 6.5L19 12l-6.5 2.5L10 21l-2.5-6.5L1 12l6.5-2.5L10 3Z', 'm19 2 1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3Z'],
    search: ['M18 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-2 6 5 5'],
    bell: ['M5 10a7 7 0 0 1 14 0c0 6 2 6 2 8H3c0-2 2-2 2-8Z', 'M9 21h6M12 1v2'],
    monitor: ['M4 3h16a2 2 0 0 1 2 2v11H2V5a2 2 0 0 1 2-2ZM12 16v5m-5 0h10', 'M12 6v7m-3-3 3 3 3-3'],
    'app-download': ['M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z', 'M10 5h4M12 8v8m-3-3 3 3 3-3M11 19h2'],
    megaphone: ['m3 9 15-5v14L3 13V9Zm15-2 3 1v6l-3 1M6 14l2 7h4l-2-6'],
    chevron: ['m9 5 7 7-7 7'],
    'arrow-right': ['M4 12h16m-6-6 6 6-6 6'],
    close: ['m6 6 12 12M6 18 18 6'],
    logout: ['M10 4H4v16h6', 'M10 12h11m-4-4 4 4-4 4'],
    copy: ['M9 3h11v14H9V3ZM6 7H3v14h11v-1'],
    flame: ['M13 2c1 5-5 6-4 10 1-1 2-2 3-2-1 3 4 3 4 0 3 3 5 5 4 8a8 8 0 0 1-15-1C2 11 8 7 13 2Z'],
    clock: ['M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM12 7v5l3 2'],
    heart: ['M20.5 4.5a5 5 0 0 1 0 7L12 21l-8.5-9.5a5 5 0 0 1 7-7L12 6l1.5-1.5a5 5 0 0 1 7 0Z'],
    providers: ['M3 3h7v7H3V3Zm11 0h7v7h-7V3ZM3 14h7v7H3v-7Zm11 0h7v7h-7v-7Z'],
    coins: ['M16 5c0 1.7-3 3-7 3S2 6.7 2 5s3-3 7-3 7 1.3 7 3ZM2 5v5c0 1.7 3 3 7 3m7-8v4M2 10v5c0 1.7 3 3 7 3', 'M22 14a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-6-2v4'],
    shield: ['m12 2 9 4v6c0 5-5 9-9 10-4-1-9-5-9-10V6l9-4Z', 'm8 12 3 3 5-6'],
    envelope: ['M4 3h16v18H4V3Zm0 0 8 8 8-8', 'M9 15h6m-3-2v5'],
    trophy: ['M7 3h10v5a5 5 0 0 1-10 0V3ZM7 5H3v3a4 4 0 0 0 4 4m10-7h4v3a4 4 0 0 1-4 4', 'M12 13v5m-4 3v-3h8v3H8Z'],
    slots: ['M5 4h14a2 2 0 0 1 2 2v14H3V6a2 2 0 0 1 2-2ZM3 8h18M9 8v9m6-9v9M3 17h18', 'M6 11h.01M12 11h.01M18 11h.01'],
    dice: ['M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z', 'M7 7h.01M17 7h.01M12 12h.01M7 17h.01M17 17h.01']
}

export const eventIcons = {
    signIn: 'calendar',
    vipSignIn: 'calendar',
    luckyWheel: 'wheel',
    extend: 'chest',
    VIP: 'diamond',
    customerServiceTelegram: 'headset',
    pinduoduo: 'gift',
    reliefMoney: 'shield',
    redPacket: 'envelope',
    gameBetting: 'coins',
    rechargeRewards: 'users',
    gameBettingRewards: 'users',
    rankingList: 'trophy',
    registerRewards: 'gift',
    customerPending: 'clock',
    rechargeGift: 'gift',
    usdtRechargeGift: 'gift',
    totalRecharge: 'coins'
}

export const categoryIcons = {
    Search: 'search',
    Popular: 'flame',
    Providers: 'providers',
    Recent: 'clock',
    Recente: 'clock',
    Favoritos: 'heart',
    Slot: 'slots'
}
